import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import color from '@deprecated-ui/_style/color';
import Image from 'global/Image';
import { Skeleton } from 'antd';
import SkeletonWrapper from 'global/Securities/components/SkeletonWrapper';
import { CardHeader, SubCompanyText, TableHeaderTextSkeleton } from './styled';
import { SymbolAvatar } from '../components/styled';

interface TableHeaderProps {
  data: {
    icon_url: string;
    symbol: string;
    name: string;
  };
  loading?: boolean;
}

const TableHeaderSkeleton = () => (
  <>
    <CardHeader>
      <Skeleton.Avatar />
      <TableHeaderTextSkeleton paragraph={{ rows: 1 }} />
    </CardHeader>
  </>
);

function TableHeader({ data, loading = false }: TableHeaderProps) {
  if (!data) return null;
  const { icon_url = '', symbol = '', name = '' } = data;

  return (
    <SkeletonWrapper skeleton={<TableHeaderSkeleton />} loading={loading}>
      <CardHeader>
        <Flex align="flex-start">
          {!icon_url ? (
            <SymbolAvatar>
              <Text color="white" family="bold" size="16px">
                {symbol[0]}
              </Text>
            </SymbolAvatar>
          ) : (
            <Image
              src={icon_url}
              style={{ width: '40px', height: '40px', background: 'white' }}
            />
          )}
          {/* @ts-expect-error */}
          <Flex direction="column" pl="15px">
            <Flex align="center">
              <Text family="bold" size="16px">
                {symbol}
              </Text>
            </Flex>
            {/* @ts-expect-error */}
            <Flex mt="3px">
              {/* @ts-expect-error */}
              <SubCompanyText size="14px" color={color.midgray} mr="5px">
                {name}
              </SubCompanyText>
            </Flex>
          </Flex>
        </Flex>
      </CardHeader>
    </SkeletonWrapper>
  );
}

export default TableHeader;
